import { type SVGProps } from "react";

export function AiDesignIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 1.5H13.5V6H12V1.5ZM12 15H13.5V19.5H12V15ZM3.75005 11.25V9.75H8.25005V11.25H3.75005ZM17.25 11.25V9.75H21.75V11.25H17.25ZM5.85605 4.665L6.91655 3.606L10.098 6.7875L9.03755 7.848L5.85605 4.6665V4.665ZM15.402 14.2125L16.4625 13.152L19.644 16.3335L18.5835 17.394L15.402 14.2125ZM2.67305 21.6375L1.61255 20.577L9.03755 13.152L10.098 14.2125L2.67305 21.6375ZM16.4625 7.848L15.402 6.7875L18.5835 3.606L19.644 4.6665L16.4625 7.848Z"
        fill="currentColor"
      />
    </svg>
  );
}
